import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=f7230ba2&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=f7230ba2&prod&lang=scss"
import style1 from "./layout.vue?vue&type=style&index=1&id=f7230ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7230ba2",
  null
  
)

export default component.exports